import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { SubAccountDetails } from '../sms-call';
import { CommonModule, DatePipe } from '@angular/common';
import { faCheckCircle, faClock, faQuestionCircle, faXmarkCircle } from '@fortawesome/free-regular-svg-icons';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faExclamationCircle, faToggleOff, faToggleOn } from '@fortawesome/free-solid-svg-icons';
import { SmsCallService } from '../sms-call.service';
import { AlertService } from '@main/alert.service';

@Component({
  selector: 'app-settings-communications-active',
  imports: [CommonModule, DatePipe, FaIconComponent],
  templateUrl: './settings-communications-active.component.html',
  styleUrl: './settings-communications-active.component.css'
})
export class SettingsCommunicationsActiveComponent implements OnInit {

  // Properties
  @Input() subAccountDetails: SubAccountDetails;
  @Output() refreshSubaccountDetails: EventEmitter<void> = new EventEmitter<void>();

  // Font Awesome Properties
  faClock = faClock;
  faXmarkCircle = faXmarkCircle;
  faCheckCircle = faCheckCircle;
  faQuestionCircle = faQuestionCircle;
  faExclamationCircle = faExclamationCircle;
  faToggleOff = faToggleOff;
  faToggleOn = faToggleOn;

  // Injections
  private smsCallService = inject(SmsCallService);
  private alertService = inject(AlertService);

  ngOnInit(): void {

  }

  // Toggle Messaging Service
  toggleMessagingService(): void {
    const status = this.isMessagingServiceActive ? "INACTIVE" : "ACTIVE";
    this.smsCallService.toggleMessagingService(status).subscribe(() => {
      this.alertService.showSuccessAlert("Messaging Service Updated");
      this.refreshSubaccountDetails.emit();
    });
  }

  get isMessagingServiceActive() { return this.subAccountDetails?.messagingService?.status == "ACTIVE"; }
}
